import DestinationHotel from '@/domain/DestinationHotel'

export default class DestinationHotelList {
  static empty() {
    return new DestinationHotelList({})
  }

  static fromJSON(cityCode, jsonHotels) {
    return new DestinationHotelList({
      cityCode: cityCode,
      hotels: jsonHotels.map(it => DestinationHotel.fromJSON(it))
    })
  }

  constructor({ cityCode, hotels }) {
    this.cityCode = cityCode
    this.hotels = hotels || []
  }

  getCodes() {
    return this.hotels.map(it => it.code)
  }

  getMORCodes() {
    if (
      global.AuthDispatcher.isLogged() ||
      !!window.Cookie.read(window.cookieDictionary.loyaltyConsentRates)
    ) {
      return this.hotels.map(it => it.code)
    } else {
      return this.hotels.filter(hotel => hotel.memberOnlyRate).map(it => it.code)
    }
  }

  getAvailableAmenityCodes() {
    return this.hotels
      .map(it => it.amenities)
      .reduce((acc, next) => acc.concat(next), [])
      .reduce((acc, next) => {
        const codes = acc.map(it => it.code)
        if (codes.includes(next.code)) {
          return acc
        } else {
          return [...acc, next]
        }
      }, [])
  }

  getAvailableRatings() {
    const ratings = {
      5: 'weExcellent',
      4.5: 'weExcellent',
      4: 'weVeryGood',
      3.5: 'weVeryGood',
      3: 'weAverage',
      2.5: 'weAverage',
      2: 'wePoor',
      1.5: 'wePoor',
      1: 'weTerrible',
      0: 'weTerrible'
    }
    const getRatingLabel = bubbleRating => ratings[bubbleRating] || 'errorrrrr'

    const uniqueNames = {}
    const uniqueRatings = {}

    const uniqueRatingsData = this.hotels
      .filter(it => it.rating && it.rating.bubbleRating)
      .filter(it => {
        const rating = it.rating.bubbleRating
        if (!uniqueRatings[rating]) {
          uniqueRatings[rating] = true
          return true
        }
        return false
      })
      .map(it => ({
        code: it.rating.bubbleRating,
        name: getRatingLabel(it.rating.bubbleRating)
      }))

    const uniqueNamesData = uniqueRatingsData.filter(item => {
      const name = item.name
      if (!uniqueNames[name]) {
        uniqueNames[name] = true
        return true
      }
      return false
    })

    return uniqueNamesData.sort((a, b) => b.code - a.code)
  }

  getAvailableHotelTypeCodes() {
    return Array.from(
      new Set(
        this.hotels
          .filter(hotel => !!hotel.types || !!hotel.type)
          .flatMap(hotel => hotel.types.map(type => type) || hotel.type)
          .map(JSON.stringify)
      ),
      JSON.parse
    )
  }

  getAvailableBrandCodes() {
    return this.hotels.reduce((acc, next) => {
      if (acc.includes(next.brand)) {
        return acc
      } else {
        return [...acc, next.brand]
      }
    }, [])
  }

  clone() {
    return new DestinationHotelList({
      ...this,
      hotels: [...this.hotels]
    })
  }

  enrichHotelsWithPrice(jsonHotels) {
    const hotelsWithPrice = this.hotels.reduce((acc, next) => {
      const foundHotel = jsonHotels.find(it => it.code === next.code)

      if (foundHotel) {
        return [
          ...acc,
          next.addPrice(
            foundHotel.priceFrom && foundHotel.priceFrom.amount,
            foundHotel.priceFrom && foundHotel.priceFrom.formattedAmount
          )
        ]
      } else {
        return acc
      }
    }, [])

    return new DestinationHotelList({
      ...this,
      hotels: hotelsWithPrice
    })
  }

  enrichHotelsWithRating(jsonHotels) {
    const hotelsWithRating = this.hotels.reduce((acc, next) => {
      const foundHotel = jsonHotels.find(it => it.code === next.code)
      if (foundHotel) {
        return [...acc, next.addRating(foundHotel.rating)]
      } else {
        return [...acc, next]
      }
    }, [])

    return new DestinationHotelList({
      ...this,
      hotels: hotelsWithRating
    })
  }
}
